export default function updateTitle(title) {
  let newTitle = `${title} | SGD Curator`;
  document.title = newTitle;
}



// WEBPACK FOOTER //
// ./lib/updateTitle.js